import { alpha, Stack, useTheme } from '@mui/material';
import { Text, TextBadge } from '@/components/DesignSystem';
import { PROGRAM_BADGE_COLOR } from '@/components/shared/ProgramTags';
import { RewardsProgramType } from '@shared/enums/RewardsProgramType';

const SECTION_STYLE_BY_TYPE = {
  [RewardsProgramType.Agronomy]: {
    badgeColor: PROGRAM_BADGE_COLOR[RewardsProgramType.Agronomy],
    label: 'AGRONOMY',
    sectionTintAlpha: 0.05,
    sectionTintColor: undefined,
  },
  [RewardsProgramType.Energy]: {
    badgeColor: PROGRAM_BADGE_COLOR[RewardsProgramType.Energy],
    label: 'ENERGY',
    sectionTintAlpha: 0.06,
    sectionTintColor: '#E68C1E',
  },
};

interface ProgramSectionHeaderProps {
  name: string,
  type: RewardsProgramType,
}

export const ProgramSectionHeader = ({
  name,
  type,
}: ProgramSectionHeaderProps) => {
  const theme = useTheme();
  const { badgeColor, label, sectionTintAlpha, sectionTintColor } = SECTION_STYLE_BY_TYPE[type];

  return (
    <Stack
      alignItems="center"
      data-testid={`${type}-program-section-header`}
      direction="row"
      spacing={1.5}
      sx={{
        backgroundColor: alpha(sectionTintColor ?? theme.palette.primary.main, sectionTintAlpha),
        borderBottom: `1px solid ${theme.palette.divider}`,
        px: '20px',
        py: '12px',
      }}
    >
      <TextBadge
        backgroundColor={alpha(badgeColor, 0.12)}
        sx={{ borderRadius: '4px', height: '20px', px: '10px' }}
        text={label}
        textColor={badgeColor}
      />
      <Text category="title-small">
        {name}
      </Text>
    </Stack>
  );
};
